import * as ActionTypes from '../actions/ActionTypes';

const initialState = {
    seenFields: [],
};

export default function FormData(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.CLEAR_SEEN_FIELDS:
            return { ...state, seenFields: [] };
        case ActionTypes.ADD_SEEN_FIELDS:
            const seenFieldPayload = Array.isArray(action.payload?.seenFields) ? action.payload?.seenFields : [];
            const updatedSeenFields = Array.from(new Set([...(state?.seenFields || []), ...seenFieldPayload]));
            return { ...state, seenFields: updatedSeenFields };
        default:
            return state;
    }
}
